import classNames from 'classnames';
import React from 'react';
import Typography from '@/components/atoms/typography/typography';
import ProfilePicture from '@/components/molecules/profile-picture/profile-picture';
import Radiobutton from '@/components/molecules/radiobutton/radiobutton';
import styles from './individual-traveler-option.module.scss';

export interface IndividualTravelerOptionItem {
  /** Indicates whether the option is disabled */
  disabled?: boolean;
  /** The first name to show */
  firstName?: Content.Components['TripPassengerDto']['firstName'];
  /** The profile picture url */
  imageUrl?: Content.Components['TripPassengerDto']['imageUrl'];
  /** Indicates whether the option is selected */
  isSelected?: boolean;
  /** The last name to show */
  lastName?: Content.Components['TripPassengerDto']['lastName'];
  /** The unique id of the traveler */
  uniquePaxHash: Content.Components['TripPassengerDto']['uniquePaxHash'];
}

export interface IndividualTravelerOptionProps {
  /** Callback when a selection is made */
  onSelect?: (
    id: Content.Components['TripPassengerDto']['uniquePaxHash'],
  ) => void;
  /** The option item to display */
  option: IndividualTravelerOptionItem;
}

const IndividualTravelerOption = ({
  onSelect,
  option,
}: IndividualTravelerOptionProps) => {
  const { firstName, disabled, imageUrl, isSelected, lastName, uniquePaxHash } =
    option;

  const handleSelect = (
    id: Content.Components['TripPassengerDto']['uniquePaxHash'],
  ) => {
    onSelect?.(id);
  };

  const fullName = `${firstName} ${lastName}`;

  return (
    <div
      className={classNames(styles.component, {
        [styles.isDisabled]: disabled,
      })}
    >
      <label className={styles.label}>
        <ProfilePicture
          firstName={firstName}
          imageUrl={imageUrl ?? undefined}
          initialsTagStyle="labelLarge"
          lastName={lastName}
          mode="invitation"
          size={48}
        />

        <span className={styles.inputWrapper}>
          <input
            checked={isSelected}
            className={styles.input}
            disabled={disabled}
            onChange={() => undefined}
            onClick={() => handleSelect(uniquePaxHash)}
            type="radio"
          />

          <span className={styles.content}>
            <Typography className={styles.fullName} tagStyle="bodyMediumBold">
              {fullName}
            </Typography>
          </span>

          <Radiobutton
            checked={isSelected}
            className={styles.radioButton}
            disabled={disabled}
            onChange={() => undefined}
            onClick={() => handleSelect(uniquePaxHash)}
          />
        </span>
      </label>
    </div>
  );
};

export default IndividualTravelerOption;
